 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {RetroDemo} from '../../types/constEnums'
import DemoGenericMeetingStage from './DemoGenericMeetingStage'


export default class DemoDiscussStage extends DemoGenericMeetingStage {
  __init() {this.__typename = 'RetroDiscussStage'}
  __init2() {this.__isNewMeetingStage = 'RetroDiscussStage'}

  __init3() {this.meetingId = RetroDemo.MEETING_ID}
  __init4() {this.isComplete = false}
  __init5() {this.isNavigable = true}
  __init6() {this.isNavigableByFacilitator = true}
  __init7() {this.phaseType = 'discuss' }
  __init8() {this.startAt = new Date().toJSON()}
  __init9() {this.viewCount = 0}
  __init10() {this.readyCount = 0}
  
  
  constructor(
     id,
     sortOrder,
     reflectionGroup,
     discussionId,
    db /* RetroDemoDB */
  ) {
    super(id, 'discuss');this.id = id;this.sortOrder = sortOrder;this.reflectionGroup = reflectionGroup;this.discussionId = discussionId;DemoDiscussStage.prototype.__init.call(this);DemoDiscussStage.prototype.__init2.call(this);DemoDiscussStage.prototype.__init3.call(this);DemoDiscussStage.prototype.__init4.call(this);DemoDiscussStage.prototype.__init5.call(this);DemoDiscussStage.prototype.__init6.call(this);DemoDiscussStage.prototype.__init7.call(this);DemoDiscussStage.prototype.__init8.call(this);DemoDiscussStage.prototype.__init9.call(this);DemoDiscussStage.prototype.__init10.call(this);
    this.reflectionGroupId = _nullishCoalesce(_optionalChain([reflectionGroup, 'optionalAccess', _ => _.id]), () => ( null))
    this.discussion =
      _nullishCoalesce(_optionalChain([db, 'optionalAccess', _2 => _2.discussions, 'access', _3 => _3.find, 'call', _4 => _4((discussion) => discussion.id === this.discussionId)]), () => ( null))
  }
}
